const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

// Date-only strings are local calendar dates; `new Date('YYYY-MM-DD')` would read them as UTC midnight.
export function parseSeedDate(value?: string | null): Date | undefined {
    if (!value) return undefined;
    const parts = DATE_ONLY.exec(value);
    if (!parts) return new Date(value);
    const [year, month, day] = [Number(parts[1]), Number(parts[2]) - 1, Number(parts[3])];
    const local = new Date(year, month, day);
    return local.getFullYear() === year && local.getMonth() === month && local.getDate() === day
        ? local
        : new Date(Number.NaN);
}
